export enum WorkingUnitType {
  Branch = "Branch",
  Depot = "Depot",
  ServiceArea = "ServiceArea",
  Account = "Account",
  Site = "Site",
}

